module.exports = false;


//////////////////
// WEBPACK FOOTER
// /app/~/core-js/modules/_library.js
// module id = ../../../../core-js/modules/_library.js
// module chunks = 4